import { defineComponent as _defineComponent } from 'vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzPlainButton, { OzPlainButtonSizePreset } from '@@/library/v4/components/OzPlainButton.vue'
import { useVirtualKeyboardHeight } from '@@/vuecomposables/virtual_keyboard_height'
import { useGlobalInputDialogStore } from '@@/pinia/global_input_dialog'
import { storeToRefs } from 'pinia'
import { nextTick, ref, watch } from 'vue'
import { defineAsyncComponent } from '@@/bits/vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalInputDialog',
  setup(__props) {

/**
 * @file This component comes as a pair with the global_input_dialog Pinia store.
 */
const OzOverlay = defineAsyncComponent(() => import('@@/library/v4/components/OzOverlay.vue'))
const OzInputDialogBox = defineAsyncComponent(() => import('@@/library/v4/components/OzInputDialogBox.vue'))

const globalInputDialogStore = useGlobalInputDialogStore()
const { virtualKeyboardHeight } = useVirtualKeyboardHeight()

const { isOpen, inputDialogData } = storeToRefs(globalInputDialogStore)
const { updateInputValue, closeInputDialog, submitInputDialog } = globalInputDialogStore

const dialogBox = ref<InstanceType<typeof OzInputDialogBox>>()

watch(
  isOpen,
  (newIsOpen: boolean): void => {
    if (newIsOpen) nextTick(() => dialogBox.value?.focus())
  },
  { immediate: true },
)

const executeHeaderTopEndContentActions = (): void => {
  if (
    inputDialogData.value.headerTopEndContent != null &&
    Array.isArray(inputDialogData.value.headerTopEndContent.actions)
  ) {
    const { actions } = inputDialogData.value.headerTopEndContent
    actions.forEach((action) => {
      if (typeof action === 'function') action()
    })
  }
}

return { __sfc: true,OzOverlay, OzInputDialogBox, globalInputDialogStore, virtualKeyboardHeight, isOpen, inputDialogData, updateInputValue, closeInputDialog, submitInputDialog, dialogBox, executeHeaderTopEndContentActions, OzIcon, OzPlainButton, OzPlainButtonSizePreset }
}

})